import { JetView, plugins } from 'webix-jet';

/**
 * Class representing the finances customer bet shop view.
 * @extends JetView
 */
export default class financescustomerBetShopView extends JetView {
    /**
     * Configures the layout of the view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        return {
            type: 'wide', // Layout type
            cols: [
                {
                    localId: 'inner:layout', // Unique identifier for the layout
                    rows: [
                        {
                            view: 'tabbar', // Tab bar component
                            localId: 'tabbar', // Unique identifier for the tab bar
                            height: 43, // Height of the tab bar
                            options: [
                                {
                                    id: 'betShopManagement.financial.bankAccountsBetShop', // Tab ID
                                    value: 'Cuentas Bancarias', // Tab label
                                },
                            ],
                        },
                        { $subview: true }, // Placeholder for subview
                    ],
                },
            ],
        };
    }

    /**
     * Initializes the view and sets up event listeners.
     */
    init() {
        this.use(plugins.Menu, this.$$('tabbar')); // Use menu plugin with tab bar
        this.on(
            this.app,
            'person:select',
            (
                person, // Event listener for person selection
            ) => this.setParam('user', person.id, true), // Set user parameter with selected person's ID
        );
    }
}

// FILE DOCUMENTED
